import React from "react";

const LoadingSpinner = ({
  size = "md",
  color = "#253FF6",
  className = "",
  text = "",
}) => {
  const sizeClasses = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8",
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`${sizeClasses[size]} relative`}>
        {Array.from({ length: 8 }, (_, i) => (
          <div
            key={i}
            className="absolute w-[3px] h-1.5 rounded-full"
            style={{
              backgroundColor: color,
              transform: `rotate(${i * 45}deg) translateY(-100%)`,
              transformOrigin: "50% 130%",
              animation: `spin-fade 0.8s linear infinite`,
              animationDelay: `${i * 0.1}s`,
              opacity: 0.8 - i * 0.1,
            }}
          />
        ))}
      </div>
      {text && <p className="mt-1 text-xs text-gray-500 font-medium">{text}</p>}

      <style>{`
        @keyframes spin-fade {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.2;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
